<template>
  <div>
    <el-carousel style="width: 100%;margin-bottom:76px" height="600px" class="carousel" arrow="never"
      indicator-position="none">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <img :src="item.picUrl" alt="" style="width: 100%; height: 100%" />
      </el-carousel-item>
    </el-carousel>
    <!-- 关于我们 -->
    <div class="about">
      <div class="content_title scrollRevealLeft">
        <span class="content_title_zh" style="color: #333333;">关于我们</span>
        <span class="content_title_en" style="color: rgba(0, 0, 0, .64);">/About Us</span>
      </div>
      <div class="about_box">
        <div class="about_box_left scrollRevealTop"></div>
        <div class="about_box_right scrollRevealBottom">
          <div class="about_box_title scrollRevealRight">
            <img :src="require('@/assets/img/about_title_icon.png')" alt="">
            <span>公司简介</span>
          </div>
          <div class="about_box_info scrollRevealRight">
            <span>京递
              是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。</span>
          </div>
        </div>
      </div>
      <div class="about_list">
        <div class="about_item scrollRevealLeft"
          style="background: linear-gradient( 137deg, rgba(255,255,255,0.86) 0%, #FFFFFF 80%, #E3E9FF 100%);">
          <img class="about_item_img" :src="require('@/assets/img/about1.png')" alt="">
          <div class="about_item_content">
            <img class="about_item_icon" :src="require('@/assets/img/about_icon1.png')" alt="">
            <div class="about_item_text">
              <div class="about_item_title"><span>企业愿景</span></div>
              <div class="about_item_info"><span>致力成为客户最信赖合作商</span></div>
              <div class="about_item_line"></div>
            </div>
          </div>
        </div>
        <div class="about_item scrollRevealTop"
          style="background: linear-gradient( 137deg, rgba(255,255,255,0.86) 0%, #FFFFFF 80%, #FFECE5 100%);">
          <img class="about_item_img" :src="require('@/assets/img/about2.png')" alt="">
          <div class="about_item_content">
            <img class="about_item_icon" :src="require('@/assets/img/about_icon2.png')" alt="">
            <div class="about_item_text">
              <div class="about_item_title"><span>企业使命</span></div>
              <div class="about_item_info"><span>物畅其流 赋能客户成长</span></div>
              <div class="about_item_line"></div>
            </div>
          </div>
        </div>
        <div class="about_item scrollRevealRight"
          style="background: linear-gradient( 137deg, rgba(255,255,255,0.86) 0%, #FFFFFF 80%, #D4EEFF 100%);">
          <img class="about_item_img" :src="require('@/assets/img/about3.png')" alt="">
          <div class="about_item_content">
            <img class="about_item_icon" :src="require('@/assets/img/about_icon3.png')" alt="">
            <div class="about_item_text">
              <div class="about_item_title"><span>企业价值观</span></div>
              <div class="about_item_info"><span>以感恩的心态善待客户 ，以用户愉快体验为己任</span></div>
              <div class="about_item_line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollReveal from "scrollreveal";
export default {
  metaInfo: {
    title: '京递快运官网 - 关于我们', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '京递快运官网 - 关于我们'
    },
    {
      name: 'description',
      content: '京递 是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。'
    }
    ],
  },
  name: "about",
  data() {
    return {
      bannerList: [
        {
          picUrl: require('@/assets/banner/banner3.png')
        }
      ],
      scrollReveal: scrollReveal(),
    };
  },
  mounted() {
    this.setScrollReveal();
  },
  methods: {
    setScrollReveal() {
      this.scrollReveal.reveal(".scrollRevealBottom", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "bottom",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "300px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealLeft", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "left",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealRight", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "right",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "200px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
      this.scrollReveal.reveal(".scrollRevealTop", {
        // 动画的时长
        duration: 800,
        // 延迟时间
        delay: 500,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: "top",
        // 回滚的时候是否再次触发动画
        reset: false,
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: "300px",
        // 其他可用的动画效果
        opacity: 0,
        easing: "cubic-bezier(0.5, 0, 0, 1)",
        scale: 0.9,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.content_title {
  position: relative;
  color: #fff;
  margin: 0 auto;
  margin-bottom: 80px;
  width: 1291px;

  &::before {
    content: '';
    width: 78px;
    height: 13px;
    border-radius: 7px;
    background: #FF8A00;
    position: absolute;
    left: 0;
    bottom: 3px;
    z-index: 1;
  }

  .content_title_zh {
    font-size: 48px;
    font-weight: 500;
    position: relative;
    z-index: 2;
  }

  .content_title_en {
    color: rgba($color: #fff, $alpha: .64);
    font-size: 24px;
    font-weight: 400;
    padding-left: 20px;
  }
}
// 关于我们
.about {
  .about_box {
    width: 1920px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 77px;

    .about_box_left {
      background: url('../../assets/img/about_img.png') no-repeat;
      background-size: cover;
      width: 1053px;
      height: 688px;
      flex-shrink: 0;
    }

    .about_box_right {
      background: url('../../assets/img/about_bg.png') no-repeat;
      background-size: cover;
      box-sizing: border-box;
      width: 1126px;
      height: 373px;
      flex-shrink: 0;
      position: relative;
      left: -259px;
      top: 65px;
      padding-top: 30px;
      padding-left: 100px;

      .about_box_title {
        width: 270px;
        height: 88px;
        background: url('../../assets/img/about_title.png') no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 30px;
        font-weight: 500;
        margin-bottom: 30px;

        img {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }
      }

      .about_box_info {
        width: 750px;
        font-size: 18px;
        color: #fff;
        font-weight: 500;
        line-height: 34px;
      }
    }
  }

  .about_list {
    width: 1291px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 60px;

    .about_item {
      width: 410px;
      height: 459px;
      box-shadow: 0px 2px 60px 0px rgba(0, 0, 0, 0.04);
      border-radius: 100px 0px 100px 0px;
      box-sizing: border-box;
      padding: 20px;

      .about_item_img {
        width: 370px;
        height: 238px;
        margin-bottom: 47px;
      }

      .about_item_content {
        display: flex;

        .about_item_icon {
          width: 73px;
          height: 73px;
          margin-right: 24px;
        }

        .about_item_text {
          flex: 1;
          color: #000;

          .about_item_title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 7px;
          }

          .about_item_info {
            font-size: 18px;
            font-weight: 400;
            margin-bottom: 18px;
          }

          .about_item_line {
            width: 35px;
            height: 5px;
            background: #FF8A00;
          }
        }
      }
    }
  }
}
</style>